// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
}

ion-icon {
  margin-right: 5px;
  font-size: 1.5em;
  margin-top: -1px;
}

.input-file-chooser {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/general components/choose-file/choose-file.component.scss","webpack://./src/components/general%20components/choose-file/choose-file.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;ACCF;;ADEA;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;ACCF;;ADEA;EACE,aAAA;ACCF","sourcesContent":["ion-item {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  cursor: pointer;\n}\n\nion-icon {\n  margin-right: 5px;\n  font-size: 1.5em;\n  margin-top: -1px;\n}\n\n.input-file-chooser {\n  display: none;\n}\n","ion-item {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  cursor: pointer;\n}\n\nion-icon {\n  margin-right: 5px;\n  font-size: 1.5em;\n  margin-top: -1px;\n}\n\n.input-file-chooser {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
